import Axios from "axios";
import { SETTINGS } from "../../properties/ApiProps";

export const DashboardRepository = {
  getHealthData: () => {
    return Axios({
      url: SETTINGS.API_URL + "health",
      method: "GET",
    });
  },
  generateToken: (params) => {
    return Axios({
      url: SETTINGS.API_URL + "vacancies/iFrame/generateToken",
      params: {
        filterParams: params,
      },
    });
  },
};
